import React, { useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import useDebounce from "../../../../../hook/useDebounce";
import { addUser, logout } from "../../../../../store/slice/userSlice";

import {
  Box,
  Button,
  Card,
  SvgIcon,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { BaseModal } from "../../../../Modal/BaseModal";
import DeleteModal from "../../../../common/DeleteModal";
import Switch from "@mui/material/Switch";
import {
  instituteProfessorSchema,
  PlanSchema,
} from "../../../../../schema/schema";
import { apiCall } from "../../../../../API/apiCall";
import Loader from "../../../../loader/Loader";
import { toast } from "react-toastify";

import DataTable from "../../../../common/DataTable";

import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import GroupsIcon from "@mui/icons-material/Groups";
import dayjs from "dayjs";
import Action from "../../../../common/Action";
import AddProfessor from "./add-professor/AddProfessor";
import EditProfessor from "./edit-professor/EditProfessor";
import { instituteProfessorListColumns } from "../../../../../utils/tableConfig";
import { useDispatch, useSelector } from "react-redux";

const ProfessorsList = () => {
  const dispatch = useDispatch();
  const userData = useSelector((st) => st?.user?.user);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState({
    isLoading: false,
    type: "",
  });
  const [formError, setFormError] = useState({});
  const [professors, setProfessors] = useState([]);
  const [modalState, setModalState] = useState({
    type: null,
    open: false,
    formData: {
      id: null,
      Fname: "",
      Lname: "",
      email: "",
      phone: "",
      totalQuantity: "",
    },
    originalData: {
      id: null,
      Fname: "",
      Lname: "",
      email: "",
      phone: "",
      totalQuantity: "",
    },
    changedFields: {},
  });

  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search.trim(), 1000);

  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = searchParams.get("currentPage") || 1;
  const pageLimit = 5;

  const [paginationData, setPaginationData] = useState({
    totalCount: 0,
    currentPage: 0,
    totalPages: 0,
    previousPage: null,
    nextPage: null,
  });

  useEffect(() => {
    setLoading({ isLoading: true, type: "getProfessors" });
    getAllProfesors(Number(currentPage), pageLimit);
  }, [currentPage, debounceValue]);

  const getAllProfesors = async (page, limit) => {
    try {
      const response = await apiCall({
        url: "/institute/professor",
        method: "GET",
        params: {
          page,
          limit: limit || pageLimit,
          searchValue: debounceValue,
          searchFields: "Fname,Lname,Email",
        },
      });
      setProfessors(response?.data?.data);
      setPaginationData(response?.pagination);
    } catch (error) {
      console.error(error);
      console.log("EEEEEEEEEEEEEEEEEEEEEEEEEEEE ", error);
      if (error.status === 401) {
        localStorage.clear();
        dispatch(logout());
        navigate("/");
      }
    } finally {
      setLoading({ isLoading: false, type: "" });
    }
  };

  const handleOpenModal = (type, item) => {
    if (type === "redirectToChildList") {
      navigate(`/institute/professor/childs/${item._id}`);
      return;
    }

    setFormError({});
    const planData = {
      id: item?._id || null,
      Fname: item?.Fname || "",
      Lname: item?.Lname || "",
      email: item?.Email || "",
      phone: item?.Mobile || "",
      totalQuantity: item?.totalQuantity || "1",
    };

    setModalState({
      type,
      open: true,
      formData: planData,
      originalData: type !== "delete" ? planData : null,
      changedFields: {},
    });

    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);

    setModalState({
      type: null,
      open: false,
      formData: {
        id: null,
      },
      changedFields: {},
    });
  };

  const handleInputChange = (field, value) => {
    setModalState((prevState) => {
      const isChanged = value !== prevState.originalData[field];

      return {
        ...prevState,
        formData: { ...prevState.formData, [field]: value },
        changedFields: { ...prevState.changedFields, [field]: isChanged },
      };
    });
  };

  const renderModalContent = () => {
    const isDisabled = !Object.values(modalState?.changedFields || {}).some(
      (field) => field
    );

    switch (modalState.type) {
      case "add":
        return (
          <AddProfessor
            isDisabled={isDisabled}
            data={modalState}
            handleCloseModal={handleCloseModal}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            formError={formError}
            isLoading={loading}
          />
        );
      case "edit":
        return (
          <EditProfessor
            isDisabled={isDisabled}
            data={modalState}
            handleCloseModal={handleCloseModal}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            formError={formError}
            isLoading={loading}
          />
        );
      case "delete":
        return (
          <DeleteModal
            handleSubmit={handleSubmit}
            handleCloseModal={handleCloseModal}
            modalName={"User"}
          />
        );
      default:
        return null;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { type, formData, originalData, changedFields } = modalState;

    const error = instituteProfessorSchema({
      email: formData?.email,
      fname: formData?.Fname,
      lname: formData?.Lname,
      phone: formData?.phone,
      totalQuantity: formData?.totalQuantity,
    });

    if (Object.keys(error).length !== 0) {
      setFormError(error);

      console.log("Error", error);
      return;
    }

    let url = "institute/professor";
    let config;

    switch (type) {
      case "add":
        {
          const { id, email, Fname, Lname, phone, ...dataWithoutId } = formData;

          config = {
            url: url,
            method: "POST",
            data: {
              ...dataWithoutId,
              professorEmail: email,
              firstName: Fname,
              lastName: Lname,
              Mobile: phone,
            },
          };
        }
        break;
      case "edit":
        {
          const payload = {};

          for (const field in changedFields) {
            if (changedFields[field]) {
              payload[field] = formData[field];
            }
          }

          config = {
            url: `${url}/${formData?.id}`,
            method: "PATCH",
            data: payload,
          };
        }
        break;
      case "delete": {
        return;
      }
    }

    setFormError({});

    try {
      setLoading({ isLoading: true, type: type });
      const response = await apiCall(config);
      console.log("RRRRRRRRRRRRRRRRRRRRR : ", response);
      console.log("RRRRRRRRRRRRRRRRRRRRR 22222: ", response);
      if (response.status || response.success) {
        if (changedFields["totalQuantity"] || type === "add") {
          const userOrignalTotalQuantity = parseInt(originalData.totalQuantity);
          const updatedQuantity = parseInt(formData?.totalQuantity);

          const qty =
            userOrignalTotalQuantity < updatedQuantity
              ? updatedQuantity - userOrignalTotalQuantity
              : userOrignalTotalQuantity - updatedQuantity;
          console.log("!!!!!!!!!!!!!!!!!!!!!!");
          let Qty;
          if (type === "add") {
            Qty = parseInt(userData.usedQuantity) + updatedQuantity;
          } else if (userOrignalTotalQuantity < updatedQuantity) {
            Qty = parseInt(userData.usedQuantity) + qty;
          } else {
            Qty = userData.usedQuantity - qty;
          }

          console.log("TTTTTTTTTT : ", Qty);

          dispatch(
            addUser({
              ...userData,
              usedQuantity: Qty,
            })
          );
        }

        toast.success(response.message);
        getAllProfesors(Number(currentPage), pageLimit);
        handleCloseModal();
        setFormError({});
      }
    } catch (err) {
      console.log("Error : ", err);
    } finally {
      setLoading({ isLoading: false, type: "" });
    }
  };

  const handletoggle = async (professorData, toggleType) => {
    try {
      const { _id } = professorData;
      let config;
      if (toggleType === "status") {
        config = {
          url: `institute/professor/${_id}`,
          method: "DELETE",
        };
        setLoading({ isLoading: true, type: "getProfessors" });
      } else {
        config = {
          url: "institute/professor/subscription/status",
          method: "PATCH",
          data: {
            professorId: _id,
          },
        };
      }

      const response = await apiCall(config);

      if (response.success) {
        toast.success(response.message);
        getAllProfesors(Number(currentPage), pageLimit);
        if (toggleType === "status") dispatch(addUser(response?.data));
      }
    } catch (err) {
      console.log("Error : ", err);
    } finally {
      setLoading({ isLoading: false, type: "" });
    }
  };

  const handlePageClick = (event) => {
    setSearchParams((prev) => {
      prev.set("currentPage", Number(event.selected) + 1);
      return prev;
    });
  };

  const handleSearchInputChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        sx={{
          mb: 2,
          mt: 2,
          p: 0,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: "#f9f9f9",
        }}
      >
        <Box
          sx={{
            margin: 0,
            background: "#fff",
            borderRadius: 1,
            mb: { xs: 2, sm: 0 },
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            alignItems: "center",
            color: "#000",
            width: "100%",
            padding: "0px ",
          }}
        >
          <Typography
            sx={{
              p: 2,
              width: "100%",
              background: "#1976d121",
            }}
          >
            <label
              style={{
                color: "#1976d1",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              {userData?.instituteName}
            </label>
          </Typography>
          <div className="d-flex flex-wrap align-items-center w-100 justify-content-between">
            <Typography
              sx={{
                p: 2,
                width: "50%",
              }}
            >
              <label
                style={{
                  fontWeight: "600",
                }}
              >
                {" "}
                Total Quantity:
              </label>{" "}
              {userData?.totalQuantity}
            </Typography>
            <Typography
              sx={{
                p: 2,
                width: "50%",
              }}
            >
              <label
                style={{
                  fontWeight: "600",
                }}
              >
                {" "}
                Used Quantity:
              </label>{" "}
              {userData?.usedQuantity}
            </Typography>
          </div>
          <div className="d-flex flex-wrap align-items-center w-100 justify-content-between">
            <Typography
              sx={{
                p: 2,
                width: "50%",
              }}
            >
              <label
                style={{
                  fontWeight: "600",
                }}
              >
                {" "}
                User Type :
              </label>{" "}
              {userData?.userType === "institute"
                ? "Institute Admin"
                : "Porfessor"}
            </Typography>
            <Typography
              sx={{
                p: 2,
                width: "50%",
              }}
            >
              <label
                style={{
                  fontWeight: "600",
                }}
              >
                {" "}
                Remaining Quantity :
              </label>{" "}
              {userData?.totalQuantity - userData?.usedQuantity}
            </Typography>
          </div>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mb: 2,
          mt: 2,
          p: 1,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          boxShadow: 2,
          backgroundColor: "#f9f9f9",
        }}
      >
        <TextField
          label="Search"
          name="name"
          className="cstmSearchBox"
          value={search}
          onChange={handleSearchInputChange}
          error={!!formError?.name}
          helperText={formError?.name}
          sx={{
            flexGrow: 1,
            mb: { xs: 2, sm: 0 },
            width: "100%",
            minWidth: { xs: "100%", sm: "300px" },
            maxWidth: "300px",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#1976d2",
              },
              "&:hover fieldset": {
                borderColor: "#1565c0",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#0d47a1",
              },
            },
          }}
        />

        <Button
          variant="contained"
          onClick={() => handleOpenModal("add")}
          sx={{
            flexShrink: 0,
            height: "45px",
            minWidth: { xs: "100%", sm: "120px" },
            backgroundColor: "#1976d2",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          Add Professor +
        </Button>
      </Box>
      <Box sx={{ height: 450 }}>
        {loading?.isLoading && loading?.type === "getProfessors" ? (
          <Loader />
        ) : professors?.length ? (
          <DataTable
            columns={instituteProfessorListColumns}
            data={professors}
            handleOpenModal={handleOpenModal}
            handletoggle={handletoggle}
          />
        ) : (
          <Typography
            variant="h5"
            color="text.secondary"
            sx={{
              textAlign: "center",
              mt: 4,
            }}
          >
            No record found
          </Typography>
        )}
      </Box>
      <div className="pagin pagination-blog mb-3">
        <ReactPaginate
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={
            isNaN(paginationData.totalPages) ? 1 : paginationData.totalPages
          }
          forcePage={Number(paginationData.currentPage - 1)}
          renderOnZeroPageCount={null}
          previousLabel="< previous"
          nextLabel="next >"
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          activeClassName="active"
        />
      </div>

      <BaseModal
        classname="base_modal_mui CstmBaseModalWidth"
        open={openModal}
        handleClose={handleCloseModal}
        maxWidth={600}
      >
        {renderModalContent()}
      </BaseModal>
    </>
  );
};

export default ProfessorsList;
